<template>
  <div class="hello">   
  

<div style="background-color:#e5e5e5;padding:15px;text-align:center;">
  <h1>Avcom Manufacturing > Contact Us</h1>
  <h3>The home of all your baking ingredients</h3>
</div>

<div style="overflow:auto">
  <div class="menu">
  <router-link to = "/" class = "main-links" style ="  text-decoration: none;  "> Home</router-link>
    <router-link to = "/AboutUs" class = "main-links" style ="  text-decoration: none;  ">About Us</router-link>
    <router-link to = "/BakingIngredients" class = "main-links" style ="  text-decoration: none;  ">Our Baking Ingredients</router-link>
    <router-link to = "/ContactUs" class = "main-links" style ="  text-decoration: none;  ">Contact Us</router-link>
  </div>

  <div class="main" style="color: white">
    <h2>FIND US HERE </h2>
    
        <h4>92 Cameroon Street </h4>
        <h4>Harare </h4>
        <h4>White House Building First Floor </h4>
        <h4>Shop Number 10</h4>
        <hr/>
       <h4> 1557 Dzivarasekwa Extension</h4>
       <h4> Dzivarasekwa</h4>
       <h4> Harare</h4>

  </div>
  

  <div class="right">
    <h2>WORKING HOURS</h2>
    <br/>
       <br/>
    <p>Monday to Saturday: 08:00 Hours to 17:00 Hours</p>
    <p>Sundays: 08:00 Hours to 12:00 Hours</p>
    <p>Calls: Any time</p>
  </div>
</div>

<hr/>
<div style="width:60%; height: 400px auto; border: 2px solid black; border-radius: 15px; color: white; margin: 0 auto;">
<div style="text-align:center;padding:10px;margin-top:7px;">
        <h2>CONTACT US ON THE FOLLOWING:</H2>
        <h3>PHONE NUMBERS:   0719327994/ 0777327994</h3>
        <h3>EMAIL:  adentchat9396@gmail.com</h3>
        <h3> FOR WHATSAPP CHAT CLICK ANY ONE ICON BELOW:   </h3>
        <P><a href="https://api.whatsapp.com/send/?phone=%2B263719327994&text&app_absent=0"><img src ="../assets/whatsapp.png" width ="80px"/></a></P>
        <p>OR</p>
        
            <p><a href="https://api.whatsapp.com/send/?phone=%2B263777327994&text&app_absent=0"><img src ="../assets/whatsapp.png" width ="80px"/></a></P>
        <br/>
                <h3> FOLLOW US ON OUR FACEBOOK PAGE   </h3>
                        <br/>

        <a href="https://www.facebook.com/Avcom-manufacturing-pvt-ltd-101934582241773/"><img src="../assets/facebook.png" width="80"></a>         

    </div>
</div>
<hr/>
 
  
<footer>
  <div style="background-color:#e5e5e5;text-align:center;padding:10px;margin-top:7px;">
        <p>OUR PHYSICAL ADDRESSES:</p>
        <p>92 Cameroon Street </p>
        <p>Harare </p>
        <p>White House Building First Floor </p>
        <p>Shop Number 10</p>
        <hr/>
       <p> 1557 Dzivarasekwa Extension</p>
       <p> Dzivarasekwa</p>
       <p> Harare</p>

    </div>
    <hr/>

   
<div style="background-color:#e5e5e5;text-align:center;padding:10px;margin-top:7px;">&copy; LearAdlib.com 2021</div>
</footer>
  </div>
</template>

<script >
export default {
  name: 'Home',
  props: {
    msg: String
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

* {
  box-sizing: border-box;
}

.menu {
  float: left;
  width: 20%;
  text-align: center;
}
.main-links:hover{

background-color: black;
color:white;
}

.menu a {
  background-color: #e5e5e5;
  padding: 8px;
  margin-top: 7px;
  display: block;
  width: 100%;
  color: black;
}

.main {
  float: left;
  width: 60%;
  padding: 0 20px;
}
.hello{
   background-image: linear-gradient(olivedrab, purple);
  width: 100%;
  padding-bottom: 10px;
  padding-top: 5px;
  padding-left: 2px;
  padding-right: 2px
}
.right {
  background-color: #e5e5e5;
  float: left;
  width: 20%;
  padding: 15px;
  margin-top: 7px;
  text-align: center;
}

@media only screen and (max-width: 620px) {
  /* For mobile phones: */
  .menu, .main, .right {
    width: 100%;
  }
}
</style>

